import { useNavigate, useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useClientLang } from '~/utils/i18n.utils'
import { setUserCoordinates } from '~/utils/location/location'
import {
	clearSearchPlaceParams,
	searchBoxFilterStyle,
} from './searchbox.helper'
import { cn } from '~/utils/misc'

type NearYouButtonProps = {
	onSuccess?: () => void
	onError?: () => void
	setSliderValue?: (value: number) => void
}

export default function SearchBoxNearYouButton({
	onSuccess,
	onError,
	setSliderValue,
}: NearYouButtonProps) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const lang = useClientLang().lngShort

	const [searchParams] = useSearchParams()
	const sp = clearSearchPlaceParams(searchParams)
	const isNearbySelected = searchParams.get('nearby') === 'true'

	const askUserLocation = async () => {
		if (setSliderValue) {
			setSliderValue(50)
		}

		await setUserCoordinates()
			.then(() => {
				navigate(
					`${lang === 'sv' ? '' : `/${lang}`}/place?nearby=true` +
						(sp.size > 0 ? '&' + sp.toString() : ''),
				)
				if (onSuccess) onSuccess()
			})
			.catch(() => {
				if (onError) onError()
			})
	}

	return (
		<button
			onClick={askUserLocation}
			className={cn(
				searchBoxFilterStyle,
				'w-auto! rounded-bl-3xl',
				isNearbySelected && 'bg-secondary/70 text-secondary-foreground',
			)}
			aria-label={t('location_near_you')}
		>
			{t('location_near_you')}
		</button>
	)
}
